module.exports = __webpack_public_path__ + "static/media/altitude_slope.14ea11b1.jpg";